<template>
    <div class="sliderbarbox" :class="{'is-show':show}" ref="sidebarCart">
        <header>
            <span>{{taxonomyText()}}</span>
            <el-button @click="deleteAll" size="small" round :disabled="deleting">一键清空</el-button>
        </header>
         
       
   
        <div class="sliderborder">
            <div class="close" @click="toggle" v-if="show"><i class="el-icon-close"></i></div>
            <ul class="operate">
                <el-tooltip class="item" content="QQ客服" placement="left" transition="">
                    <li>
                        <a class="sliderbar_icon" target="_blank" :href="config.chat_url"> <i  class="iconfont icon-qq"></i></a>
                    </li>
                </el-tooltip>

                <el-tooltip class="item" content="联系客服" placement="left">
                    <li>
                        <a class="sliderbar_icon" @click="csVisible=true"> <i  class="iconfont icon-kefu"></i></a>
                    </li>
                </el-tooltip>


                <el-tooltip class="item" effect="dark" content="购物车" placement="left">
                    <li class="cart" @click="toggle" id="global-cart-in">
                            <i class="iconfont icon-gouwuche2" style="margin-bottom:8px"></i>
                        <span>{{dataSource[platform_id].length}}</span>
                    </li>
                </el-tooltip>

                <el-tooltip effect="dark" content="投放需求单" placement="left">
                    <li>
                        <a href="/nd" target="_blank"><i class="iconfont icon-xuqiu"></i></a>
                    </li>
                </el-tooltip>

                <el-tooltip class="item" content="回到网站顶部" placement="left" style="margin-top:12px">
                    <li @click="goback">
                        <i class="iconfont icon-top"></i>
                    </li>
                </el-tooltip>

            </ul>
    
        </div>
        <el-dialog title="导出购物车·" :visible.sync="showExport" width="422"></el-dialog>
        <!-- <div v-else style="font-size:12px;text-align:center;padding-top:">购物车空空的，赶快去挑选心仪的媒体吧~<br/> <router-link to="/resource/news" style="font-size:12px;color:#ff8900">去媒体中看看</router-link> </div> -->

        <el-dialog
            title="需要帮助吗？欢迎致电我们的客户经理"
            :append-to-body="true"
            :visible.sync="csVisible"
            class="dialog-body"
            width="500px">
            <div class="cs-box">
                <div class="info" v-if="customerService.mobile">
                    <div class="c_name">
                        <div class="label">联系人：</div>
                        <div class="value">{{customerService.name}}</div>
                    </div>
                    <div class="c_name">
                        <div class="label">QQ号码：</div>
                        <div class="value">{{customerService.qq||'无'}} <a type="text" class="link active" @click="openqq"><small>立即咨询</small></a></div>
                    </div>
                    <div class="c_name">
                        <div class="label">手机号码：</div>
                        <div class="value">{{customerService.mobile}}</div>
                    </div>
                </div>

                <div class="wechat-qrcode" v-if="customerService.wechat_qrcode">
                    <el-tooltip class="item" effect="dark" content="打开微信扫一扫，添加我的微信号" placement="top">
                        <img :src="customerService.wechat_qrcode" width="160" height="160" />
                    </el-tooltip>
                </div>
            </div>

            
        </el-dialog>

    </div>

</template>


<script>
    export default {
        props:{platform_id:{default:'750'}},
        data() {
            return {
                show: false,
                showExport: false,
                time: 60,
                deleting: false,
                csVisible:false
            }
        },
        computed:{
            dataSource(){
                return this.$store.state.cart
            },
            loading(){
                return this.$store.state.cartLoading
            },
            taxonomies(){
                return this.$store.state.taxonomy
            },
            money(){
                var money = 0;
                this.dataSource[this.platform_id].forEach(element => {
                   money += parseInt(element.price);
                 });
                return  money.toFixed(2);
            },
            customerService(){
                return this.$store.state.customerService;
            }
        },
        methods: {
            load(platform_id){
                this.$event_bus.$emit('CartLoad',platform_id)
                this.$store.commit('changeCartPlatform',platform_id)
            },
            taxonomyText(){
                
                const tx = JSON.parse(JSON.stringify(this.taxonomies));
                return tx.find((v)=>v.id==this.platform_id)['name']+'购物车'
            },
            toggle(e) {
                this.show = !this.show;
            },
            alert(val) {
                this.$msgbox({
                    title: "导出成功",
                    closeOnClickModal: false,
                    showCancelButton: false,
                    closeOnPressEscape: false,
                    message: "<a href=" + val + "  >导出成功，点击下载</a>",
                    dangerouslyUseHTMLString: true,
                    showCancelButton: false,
                    confirmButtonText: "确定"
                });
            },
            deleted(item_id) {
                this.deleting = true;
                this.$http
                    .delete("/cart/" + item_id)
                    .then(response => {
                        if (response.success) {
                            this.load(this.platform_id);
                            this.$emit("reload");
                        }
                    })
                    .catch()
                    .then(() => {
                        this.deleting = false;
                    });
            },
            goback() {
                (function smoothscroll() {
                    var currentScroll =
                        document.documentElement.scrollTop || document.body.scrollTop;
                    if (currentScroll > 0) {
                        window.requestAnimationFrame(smoothscroll);
                        window.scrollTo(0, currentScroll - currentScroll / 5);
                    }
                })();
            },
            openqq() {
                //打开qq在线交谈
                window.open(
                    this.config.chat_url,
                    "_blank",
                    "height=800, width=644,toolbar=no,scrollbars=no,menubar=no,status=no"
                );
            },
            deleteAll() {
                var cart_arr = [];
                var cart_ids = "";
                this.dataSource[this.platform_id].forEach(element => {
                    if (this.dataSource[this.platform_id].length > 0) {
                        cart_arr.push(element.item_id);
                        cart_ids = cart_arr.join(",");
                    }
                });
                this.deleting = true;
                this.$http
                    .delete("/cart/" + cart_ids)
                    .then(response => {
                        if (response.success) {
                            this.$emit("reload");
                            this.load(this.platform_id);
                        }
                    })
                    .catch()
                    .then(() => {
                        this.deleting = false;
                    });
            }
        }
    };

</script>


<style scoped lang="less">
    

    .item-title {
        height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 4px;
        font-size: 14px;
    }

    .item-price {
        margin: 0;
        font-size: 12px;
        color:#9E9E9E
    }

    .taxonomy-selecter {
        display: flex;
        height: 62px;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        width: 100%;
        bottom: 92px;
    }

    .taxonomy-selecter>li{
        width: 24px;
        height: 24px;
        background-size: cover !important;
    }

    .taxonomy-selecter>li.woa{
        background: url("https://static.711.cn/material/icon/v2/woa_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.woa.active {
        background: url("https://static.711.cn/material/icon/v2/woa.png") no-repeat;
    }

    .taxonomy-selecter>li.video {
        background: url("https://static.711.cn/material/icon/v2/video_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.video.active {
        background: url("https://static.711.cn/material/icon/v2/video.png") no-repeat;
    }

    .taxonomy-selecter>li.news {
        background: url("https://static.711.cn/material/icon/v2/news_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.news.active {
        background: url("https://static.711.cn/material/icon/v2/news.png") no-repeat;
    }

    .taxonomy-selecter>li.weibo {
        background: url("https://static.711.cn/material/icon/v2/weibo_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.weibo.active {
        background: url("https://static.711.cn/material/icon/v2/weibo.png") no-repeat;
    }

    .taxonomy-selecter>li.live {
        background: url("https://static.711.cn/material/icon/v2/live_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.live.active {
        background: url("https://static.711.cn/material/icon/v2/live.png") no-repeat;
    }

     .taxonomy-selecter>li.xhs {
        background: url("https://static.711.cn/material/icon/v2/xhs_gray.png") no-repeat;
    }

    .taxonomy-selecter>li.xhs.active {
        background: url("https://static.711.cn/material/icon/v2/xhs.png")  no-repeat;
    }

    .taxonomy-selecter>li>span {
        width: 25px;
        height: 25px;
        display: inline-block;
        background-color: #999999;
        color: #ffffff;
        line-height: 25px;
        text-align: center;
        border-radius: 50%;
        margin-top: -10px;
        margin-left: 15px;
        font-size: 12px;
        vertical-align: top;
    }

    .taxonomy-selecter>li.active>span {
        background: #FF622B;
    }

    .error {
        cursor: pointer;
        font-size: 16px;
        color: #dcdfe6;
    }

    .allshop {
        overflow-y: auto;
        position: absolute;
        width: 100%;
        top: 70px;
        bottom: 92px;
        box-shadow: 0 17px 10px -8px #f9f9f9 inset, 0px -17px 10px -8px #f9f9f9 inset;
    
    }

    .sliderbarbox {
        height: 100%;
        position: fixed;
        right: -280px;
        width: 280px;
        top: 0;
        background: #fff;
        transition: 0.3s;
        z-index: 10;
        &.is-show {
            transform: translate(-280px);
        }
    }

    .sliderli {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 4px 0px;
        border-bottom: 1px solid #F5F5F5;
        margin: 0 12px;
    }

    .sliderli>img {
        width: 12px;
        height: 12px;
        margin-top: 15px;
    }

    .sliderli>img:first-child {
        width:45px;
        height: 45px;
        margin-top: 0px;
        border-radius: 50%;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
    }

    .sliderli>div {
        flex: 1;
        margin: 0 8px;
        overflow: hidden;
    }

    header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 67px;
        padding-left: 12px;
        padding-right: 12px;
    }

    header>span:first-child {
        font-size: 16px;
    }

    header>span:nth-child(2) {
        cursor: pointer;
        height: 30px;
        border-radius: 3px;
        background-color: #3aa0e7;
        color: #fff;
        padding: 4px 10px;
        line-height: 30px;
    }

    footer {
        width: 100%;
        position: absolute;
        bottom: 0px;
        border-top: 1px solid #eaeaea;
        padding-bottom: 12px;
        padding-top: 12px;
    }

    footer>div>button {
        width: 190px;
        margin-top: 16px;
    }

    footer>div>span {
        display: inline-block;
        color: #999999;
        margin-left: 12px;
        margin-right: 12px;
        font-size: 12px;
    }

    footer>.has-selected {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    footer>p {
        display: flex;
        height: 30px;
        line-height: 30px;
    }

    footer>p>span {
        width: 50%;
        text-align: center;
    }

    .sliderborder{
        color: #ffffff;
        position: absolute;
        top: 0;
        width: 45px;
        height: 100%;
        box-shadow: inset -5px 0px 5px -4px rgba(0, 0, 0, 0.1);
        border-right: 2px solid #FF622B;
        left: -47px;
        &:hover {
            cursor: pointer;
        }
        .close{
            background-color: #ff622b;
            border-top-left-radius: 7px;
            border-bottom-left-radius: 7px;
            box-shadow: -2px 0px 3px -2px #9e9d9d;
            text-align: center;
            padding-top: 12px;
            padding-bottom: 12px;
            margin-top: 14px;
        }
        .iconfont {
            font-size: 24px;
        }
        .operate{
            position: absolute;
            width: 100%;
            top: 210px;
            background-color: #fffbf9;
            border-top-left-radius: 7px;
            border-bottom-left-radius: 7px;
            box-shadow: -2px 0px 3px -2px #9e9d9d;
            border: 2px solid #FF622B;
            border-right: none;
            li{
                width: 100%;
                display: flex;
                height: 42px;
                justify-content: center;
                align-items: center;
                margin-bottom: 8px;
                margin-top: 8px;
                
                a{
                    
                }
                &:hover,&:hover a{
                    background: #FF622B;
                    color: #fff;
                }
            }
            .cart {
                padding-top: 4px;
                padding-bottom: 4px;
                height: 70px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                &:hover span{
                    background-color:#fff;
                    
                }
            }
            .cart>span {
                border-radius: 50%;
                background-
                color: #fff;
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 12px;
            }
            .cart>p {
                word-wrap: break-word;
                width: 14px;
                font-size: 14px;
            }
        }
    }

    .sliderbar_icon {
        display: inline-block;
        width: 25px;
        height: 25px;
    }

    .dialog-body /deep/ .el-dialog__body{
        background: url(https://static.711.cn/assets/image/bg/line_1.png) right top no-repeat;
        padding: 24px;
    }
    .cs-box{
        display: flex;
        align-items: center;
        .info{
            flex:1;
            .c_name{
                &:last-child{
                    margin-bottom:0
                }
                margin-bottom:12px;
                .label{
                    font-size: 12px;
                    margin-bottom: 4px;
                    color: #9E9E9E;
                }
                .value{
                    font-size: 16px;
                }
            }
            
        }
        .wechat-qrcode{
            flex:1;
            text-align: right;
            img{
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            }
        }
    }


/**
 * ----------------------------------------
 * animation wobble-hor-bottom
 * ----------------------------------------
 */

 .cart.shake>i {
	-webkit-animation: shake-bottom 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
	        animation: shake-bottom 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
}
@-webkit-keyframes shake-bottom {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
    -webkit-transform-origin: 50% 100%;
            transform-origin: 50% 100%;
  }
  10% {
    -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
  }
  20%,
  40%,
  60% {
    -webkit-transform: rotate(-4deg);
            transform: rotate(-4deg);
  }
  30%,
  50%,
  70% {
    -webkit-transform: rotate(4deg);
            transform: rotate(4deg);
  }
  80% {
    -webkit-transform: rotate(-2deg);
            transform: rotate(-2deg);
  }
  90% {
    -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
  }
}
@keyframes shake-bottom {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
    -webkit-transform-origin: 50% 100%;
            transform-origin: 50% 100%;
  }
  10% {
    -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
  }
  20%,
  40%,
  60% {
    -webkit-transform: rotate(-4deg);
            transform: rotate(-4deg);
  }
  30%,
  50%,
  70% {
    -webkit-transform: rotate(4deg);
            transform: rotate(4deg);
  }
  80% {
    -webkit-transform: rotate(-2deg);
            transform: rotate(-2deg);
  }
  90% {
    -webkit-transform: rotate(2deg);
            transform: rotate(2deg);
  }
}


</style>
